<!-- Screenname:PackSize Master Creation
Developer Name:Bharanidharan.
Created date on:1/02/2023
Last Working date on:23/03/2023
Comments and Suggestions:
TS File:GenericMasterService -->

<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? $t('createpacksize.EditCreateanewPacksize')
        : $t('createpacksize.CreateanewPacksize')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextInput
              v-model="packsizeform.Code"
              placeholder=" "
              :requiredIcon="true"
              clearable
              name="PackID"
              id="PackID"
              :label="$t('createpacksize.PackID')"
              :rules="{ required: true }"
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextInput
              v-model="packsizeform.Name"
              placeholder=" "
              :requiredIcon="true"
              name="Pack Name"
              id="Pack Name"
              :label="$t('createpacksize.Pname')"
              :rules="{ required: true }"
              clearable
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextInput
              v-model="packsizeform.Qty"
              placeholder=" "
              :requiredIcon="true"
              name="Quantity"
              id="Quantity"
              :label="$t('createpacksize.QUANTITY')"
              :rules="{ required: true, numeric: true, nonzeroable: true }"
              clearable
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="(showDialog = false), IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast class="p-toast-message" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import PackSizeservice from "../../../../Service/PackSizeService";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import { useToast } from "primevue/usetoast";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextInput,
    createdsuccessfully,
    EditConfirmation,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
  },
  setup(props, { emit }) {
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref({
      EntityId: 0,
    });
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    Entitydata.value.EntityId = props.EntityId;
    const model: any = ref(props.selectedItem);
    const showDialog = ref(false);
    const successpop = ref(false);
    const Editmodel = ref(false);
    const updatepop = ref(false);
    const toast = useToast();
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const alreadyexistpop = ref(false);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    const packsizeform = ref({
      Id: 0,
      Code: "",
      Name: "",
      Qty: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(packsizeform.value));

    //Get Value from Table and show in Popup
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      try {
        debugger;
        label.value = t('btn.update');
        let Id = model.value.Id;
        let response = await PackSizeservice.getdata(Id);
        let datas = response["result"];
        Object.keys(packsizeform.value).forEach((key) => {
          if (datas[key]) packsizeform.value[key] = datas[key];
        });
        Editmodel.value = false;
        emit("loaderhide");

        // showDialog.value = false;
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    }

    //Save Fn
    const IsSubmit = handleSubmit(async (values) => {
      Saveloading.value = true;
      emit("loadershow");
      try {
        let result: any;
        let msg = "";
        packsizeform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        packsizeform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        packsizeform.value.BranchId = 0;
        packsizeform.value.HospitalId = HospitalId;
        packsizeform.value.ModifiedBy = UserId;
        packsizeform.value.CreatedBy = UserId;
        packsizeform.value.EntityId = Number(Entitydata.value.EntityId);
        if (packsizeform.value.Id != 0) {
          packsizeform.value.EntityOperationId = props.OperationID.UpdateId;
          const result = await PackSizeservice.updatedata(packsizeform.value);
          msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            emit("loaderhide");
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          packsizeform.value.EntityOperationId = props.OperationID.CreateId;
          const result = await PackSizeservice.createdata(packsizeform.value);
          msg = result["ErrorInfo"].ErrorCode;
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            emit("loaderhide");
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        console.log(error);
      }
    });

    //Create-Popup
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }

    // Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      packsizeform.value.Name = "";
      //showDialog.value = true
    }
    //Clear Value Fn
    const IsClear = () => {
      Object.assign(packsizeform.value, copydataModel);
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    };

    //Auto Generic Code for PackSize Code
    async function GetCode() {
      debugger;
      let data = {
        // FormId: 21,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      packsizeform.value.Code = result;
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    return {
      model,
      packsizeform,
      IsCreate,
      IsEdit,
      IsClear,
      showDialog,
      GetCode,
      errors,
      IsSubmit,
      successpop,
      Editmodel,
      closetrigger,
      updatepop,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      Saveloading,
    };
  },
});
</script>

<style>
/* .p-toast-message {
  font-size: 12px; 
  padding: 4px 8px; 
  border-radius: 4px; 
  max-width: 300px; 
  height: 32px; 
  line-height: 1.2; 
} */

.p-toast-message {
  font-size: 16px;
  /* reduce font size */
  padding: 4px 8px;
  /* reduce padding */
  border-radius: 4px;
  /* adjust border radius */
  max-width: 350px;
  /* adjust maximum width */
  height: 80px;
  /* adjust height */
  line-height: 1.5;
  /* adjust line-height */
}
</style>
